import { call, put } from 'redux-saga/effects';

import {
  cancelJourneyCampaignAlerts,
  rescheduleJourneyCampaignAlerts,
  updateWorkflowStatus,
} from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { UpdateWorkflowStatusRequestAction, actions } from '../actions';

export default function* updateWorkflowStatusSaga(
  action: UpdateWorkflowStatusRequestAction,
): Generator<any, void, any> {
  try {
    const {
      workflowIds,
      enabled,
      shouldCancelAlerts = false,
      shouldRescheduleAlerts = false,
    } = action.payload;
    // get the first element because this saga only handles singular actions for
    // now the responses is an array of objects
    const [response] = yield call(updateWorkflowStatus, workflowIds, enabled);
    yield put(actions.updateWorkflowStatusResponse(response.workflowId, response.enabled));

    yield put(
      addPositiveToast(
        enabled ? 'Successfully enabled journey' : 'Successfully disabled journey and campaigns',
      ),
    );

    if (shouldCancelAlerts) {
      yield call(cancelJourneyCampaignAlerts, workflowIds);
    } else if (shouldRescheduleAlerts) {
      yield call(rescheduleJourneyCampaignAlerts, workflowIds);
    }
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.updateWorkflowStatusError(err));
    const message = `Error updating journey status. Please try again later.`;
    yield put(addNegativeToastWithErrorId(message, 'updateWorkflowStatusSaga'));
  }
}
